module.exports = __webpack_public_path__ + "img/istp.329d7998.png";